import type {ListSupplierFunctionsSearchInput} from "./list-supplier-functions.schema";

import {listSupplierFunctions} from "@project/sdk/engineering";
import {ListSupplierFunctionsResponse} from "@project/sdk/engineering/zod";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {supplierFunctionKeys} from "../../../supplierFunction-keys";

import {listSupplierFunctionsSearchSchema} from "./list-supplier-functions.schema";

export function listSupplierFunctionsQueryOptions(rawInput: ListSupplierFunctionsSearchInput) {
  const params = listSupplierFunctionsSearchSchema.parse(rawInput);

  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: supplierFunctionKeys.list(params),
    queryFn: async ({signal}) =>
      ListSupplierFunctionsResponse.parse(await listSupplierFunctions(params, {signal})),
  });
}
